"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesType = exports.SalarySystemSettingTableName = exports.SalarySystemSettingKey = exports.RoundingMethod = exports.PenaltyType = exports.OrderStatus = exports.OrderItemStatus = exports.OrderCourse = exports.ItemCategory = exports.HostStatus = exports.ExpenseType = exports.DeviceType = exports.AdminType = exports.AccountReceivableType = void 0;
/** The type of AccountReceivableType */
var AccountReceivableType;
(function (AccountReceivableType) {
    AccountReceivableType["ACCOUNT_RECEIVABLE"] = "ACCOUNT_RECEIVABLE";
    AccountReceivableType["DEPOSIT"] = "DEPOSIT";
})(AccountReceivableType = exports.AccountReceivableType || (exports.AccountReceivableType = {}));
/** The type of AdminType */
var AdminType;
(function (AdminType) {
    AdminType["ADMIN"] = "ADMIN";
    AdminType["COLLECTOR"] = "COLLECTOR";
    AdminType["MASTER"] = "MASTER";
})(AdminType = exports.AdminType || (exports.AdminType = {}));
/** The type of DeviceType */
var DeviceType;
(function (DeviceType) {
    DeviceType["CASHIER"] = "CASHIER";
    DeviceType["HALL"] = "HALL";
    DeviceType["KITCHEN"] = "KITCHEN";
    DeviceType["OFFICE_STAFF"] = "OFFICE_STAFF";
    DeviceType["VIEWER"] = "VIEWER";
})(DeviceType = exports.DeviceType || (exports.DeviceType = {}));
/** The type of ExpenseType */
var ExpenseType;
(function (ExpenseType) {
    ExpenseType["CONSUME"] = "CONSUME";
    ExpenseType["DEPOSIT"] = "DEPOSIT";
})(ExpenseType = exports.ExpenseType || (exports.ExpenseType = {}));
/** The type of HostStatus */
var HostStatus;
(function (HostStatus) {
    HostStatus["ACTIVE"] = "ACTIVE";
    HostStatus["LEAVING"] = "LEAVING";
    HostStatus["RESIGNED"] = "RESIGNED";
})(HostStatus = exports.HostStatus || (exports.HostStatus = {}));
var ItemCategory;
(function (ItemCategory) {
    ItemCategory["BASIC_CHARGE"] = "BASIC_CHARGE";
    ItemCategory["BRANDY"] = "BRANDY";
    ItemCategory["CAN_BOTTLE"] = "CAN_BOTTLE";
    ItemCategory["CHAMPAGNE"] = "CHAMPAGNE";
    ItemCategory["CHAMPAGNE_BRANDY"] = "CHAMPAGNE_BRANDY";
    ItemCategory["COCKTAIL"] = "COCKTAIL";
    ItemCategory["FIRST"] = "FIRST";
    ItemCategory["FIRST_SERVE"] = "FIRST_SERVE";
    ItemCategory["FIRST_TIME_ORDER"] = "FIRST_TIME_ORDER";
    ItemCategory["FOOD"] = "FOOD";
    ItemCategory["FREE_DRINK"] = "FREE_DRINK";
    ItemCategory["INSIDE_CALL"] = "INSIDE_CALL";
    ItemCategory["LIQUEUR"] = "LIQUEUR";
    ItemCategory["NIHONSHU"] = "NIHONSHU";
    ItemCategory["OTHER"] = "OTHER";
    ItemCategory["SHOCHU"] = "SHOCHU";
    ItemCategory["SHOT"] = "SHOT";
    ItemCategory["SOFT_DRINK"] = "SOFT_DRINK";
    ItemCategory["TOKYO_MENU"] = "TOKYO_MENU";
    ItemCategory["UNIQUE_ORDER"] = "UNIQUE_ORDER";
    ItemCategory["WINE"] = "WINE";
})(ItemCategory = exports.ItemCategory || (exports.ItemCategory = {}));
/** The type of orderCourse */
var OrderCourse;
(function (OrderCourse) {
    OrderCourse["COMPETITOR_NO_SALES"] = "COMPETITOR_NO_SALES";
    OrderCourse["FIRST_TIME"] = "FIRST_TIME";
    OrderCourse["NORMAL"] = "NORMAL";
    OrderCourse["ONE_HOUR_NO_EXTENSION"] = "ONE_HOUR_NO_EXTENSION";
})(OrderCourse = exports.OrderCourse || (exports.OrderCourse = {}));
/** The type of OrderItemStatus */
var OrderItemStatus;
(function (OrderItemStatus) {
    OrderItemStatus["CANCELED"] = "CANCELED";
    OrderItemStatus["OPENED"] = "OPENED";
    OrderItemStatus["SERVED"] = "SERVED";
})(OrderItemStatus = exports.OrderItemStatus || (exports.OrderItemStatus = {}));
/** The type of OrderStatus */
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["CANCELED"] = "CANCELED";
    OrderStatus["COMPLETED"] = "COMPLETED";
    OrderStatus["IN_PROGRESS"] = "IN_PROGRESS";
})(OrderStatus = exports.OrderStatus || (exports.OrderStatus = {}));
/** The type of PenaltyType */
var PenaltyType;
(function (PenaltyType) {
    PenaltyType["ATTENDANCE"] = "ATTENDANCE";
    PenaltyType["STORE"] = "STORE";
})(PenaltyType = exports.PenaltyType || (exports.PenaltyType = {}));
/** The type of RoundingMethod */
var RoundingMethod;
(function (RoundingMethod) {
    RoundingMethod["CEIL"] = "CEIL";
    RoundingMethod["FLOOR"] = "FLOOR";
    RoundingMethod["ROUND"] = "ROUND";
})(RoundingMethod = exports.RoundingMethod || (exports.RoundingMethod = {}));
/** The type of SalarySystemSettingKey */
var SalarySystemSettingKey;
(function (SalarySystemSettingKey) {
    SalarySystemSettingKey["AMOUNT2_CONDITION_SALES"] = "AMOUNT2_CONDITION_SALES";
    SalarySystemSettingKey["JIYURAN_NAME_1"] = "JIYURAN_NAME_1";
    SalarySystemSettingKey["JIYURAN_NAME_2"] = "JIYURAN_NAME_2";
    SalarySystemSettingKey["JIYURAN_NAME_3"] = "JIYURAN_NAME_3";
    SalarySystemSettingKey["JIYURAN_NAME_4"] = "JIYURAN_NAME_4";
    SalarySystemSettingKey["JIYURAN_NAME_5"] = "JIYURAN_NAME_5";
    SalarySystemSettingKey["JIYURAN_NAME_6"] = "JIYURAN_NAME_6";
    SalarySystemSettingKey["JIYURAN_NAME_7"] = "JIYURAN_NAME_7";
    SalarySystemSettingKey["JIYURAN_NAME_8"] = "JIYURAN_NAME_8";
    SalarySystemSettingKey["JIYURAN_NAME_9"] = "JIYURAN_NAME_9";
    SalarySystemSettingKey["JIYURAN_NAME_10"] = "JIYURAN_NAME_10";
    SalarySystemSettingKey["SALES_TYPE"] = "SALES_TYPE";
})(SalarySystemSettingKey = exports.SalarySystemSettingKey || (exports.SalarySystemSettingKey = {}));
/** The type of SalarySystemSettingTableName */
var SalarySystemSettingTableName;
(function (SalarySystemSettingTableName) {
    SalarySystemSettingTableName["KIHONKYU"] = "KIHONKYU";
    SalarySystemSettingTableName["SHIMEI_NO_SHO"] = "SHIMEI_NO_SHO";
    SalarySystemSettingTableName["URIAGE_NO_SHO"] = "URIAGE_NO_SHO";
    SalarySystemSettingTableName["URIAGE_TASSEI_SHO"] = "URIAGE_TASSEI_SHO";
})(SalarySystemSettingTableName = exports.SalarySystemSettingTableName || (exports.SalarySystemSettingTableName = {}));
/** The type of SalesType */
var SalesType;
(function (SalesType) {
    SalesType["SHOKEI"] = "SHOKEI";
    SalesType["SOURIAGE"] = "SOURIAGE";
})(SalesType = exports.SalesType || (exports.SalesType = {}));
//# sourceMappingURL=graphql.js.map